module.exports = __webpack_public_path__ + "5a467597cf0c1a3d8ae368a4d4567472.fbx";